import styled from 'styled-components'

export const StyledTableHeader = styled.div`
display: flex;
align-items: center;
margin-bottom: 1em;
margin-top: 2em;
gap: 10px;
 .title {
  font-weight: bold;
  font-size: 15px !important;
 }
`